import { Text } from "@chakra-ui/react";

type Props = {
  current: number;
  previous: number;
  /** "percent" is the relative change; "points" the difference of two percentages. */
  mode?: "percent" | "points";
};

function formatMagnitude(value: number) {
  const magnitude = Math.abs(value);
  return magnitude < 10
    ? (Math.round(magnitude * 10) / 10).toString()
    : Math.round(magnitude).toString();
}

/**
 * The change from a compared batch, in brackets: green with a "+" when it went up, red with a "-"
 * when it went down. The sign carries the direction too, so it does not rely on color alone.
 */
export default function PayrollAuditChange(props: Props) {
  const label = (() => {
    if (props.mode === "points") {
      const difference = props.current - props.previous;
      return { value: difference, text: `${formatMagnitude(difference)} pts` };
    }
    if (props.previous === 0) {
      return props.current === 0 ? { value: 0, text: "0%" } : { value: props.current, text: "new" };
    }
    const change = ((props.current - props.previous) / Math.abs(props.previous)) * 100;
    return { value: change, text: `${formatMagnitude(change)}%` };
  })();

  // Rounds to zero: show it as unchanged rather than "+0%".
  const isUnchanged = label.text === "0%" || label.text === "0 pts";
  const sign = isUnchanged || label.text === "new" ? "" : label.value > 0 ? "+" : "−";
  const color = isUnchanged ? "gray.500" : label.value > 0 ? "green.600" : "red.600";

  return (
    <Text as="span" color={color} fontSize="0.85em" fontWeight="medium" ml={1} whiteSpace="nowrap">
      ({sign}
      {label.text})
    </Text>
  );
}
